export type UpdateUserErrorCode = 'PERMISSION_DENIED' | 'UNKNOWN';

export class UpdateUserError extends Error {
    code: UpdateUserErrorCode;
    constructor(code: UpdateUserErrorCode, message: string) {
        super(message);
        this.code = code;
    }
}
